import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Masonry from "react-masonry-css";
import { removeHashTag } from "../common/removeHashTag";

function formatDate(dateString) {
  if (!dateString) return "";
  const d = new Date(dateString);
  return d
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .replace(/,/g, "");
}

const BlogPagination = ({ data }) => {
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [showPagination, setShowPagination] = useState(false);

  const breakpointColumnsObj = {
    default: 3,
    1100: 3,
    700: 2,
    500: 1,
  };

  const masonryRef = useRef(null);
  const itemsPerPage = 6;

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = data.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(data.length / itemsPerPage);

  useEffect(() => {
    setShowPagination(pageCount > 1);
  }, [pageCount]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`,
    );
    setItemOffset(newOffset);
    setCurrentPage(event.selected);
  };

  function truncateText(text, maxLength = 100) {
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    } else {
      return text;
    }
  }

  // console.log("currentItems", currentItems);
  return (
    <>
      <div ref={masonryRef} className="bloggridview">
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {currentItems.map((item) => (
            <div className="my-masonry-grid_column" key={item.id}>
              <div className="item">
                <div className="blog-img">
                  <img src={item.image} alt={item.title} />
                  <h6>{formatDate(item.created_at)}</h6>
                </div>
                <div className="item-detail">
                  <div className="admin-detail">
                    {item.tags && (
                      <span>
                        {removeHashTag(item.tags)
                          .split(",")
                          .map((t) => t)
                          .join("  ")}
                      </span>
                    )}
                  </div>

                  <h3>
                    <Link to={`/blog/${item.id}`}>{item.title}</Link>
                  </h3>

                  <div
                    dangerouslySetInnerHTML={{
                      __html: truncateText(
                        item.small_desc || item.blog_body || "",
                      ),
                    }}
                  />

                  <Link to={`/blog/${item.id}`}>READ MORE +</Link>
                </div>
              </div>
            </div>
          ))}

          {/* Your Masonry items go here */}
          {/* <div className="my-masonry-grid_column"><img src="/images/blog-img-1.jpg" alt="" /></div>
          <div className="my-masonry-grid_column"><img src="/images/blog-img-2.jpg" alt="" /></div>
          <div className="my-masonry-grid_column"><img src="/images/blog-img-3.jpg" alt="" /></div>
          <div className="my-masonry-grid_column"><img src="/images/blog-img-1.jpg" alt="" /></div>
          <div className="my-masonry-grid_column"><img src="/images/blog-img-2.jpg" alt="" /></div>
          <div className="my-masonry-grid_column"><img src="/images/blog-img-3.jpg" alt="" /></div> */}

        </Masonry>
      </div>

      {showPagination && (
        <ReactPaginate
          breakLabel=""
          nextLabel="Next"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="Previous"
          forcePage={currentPage}
          renderOnZeroPageCount={null}
          previousClassName={currentPage === 0 ? "disabled" : ""}
          previousLinkClassName={currentPage === 0 ? "disabled-link" : ""}
          className="pagination"
        />
      )}
    </>
  );
};

export default BlogPagination;
